import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/shared/api/http';

/**
 * D12: server state lives in TanStack Query. Retrying an unauthenticated or forbidden request
 * only burns time, so retries are limited to what a retry can actually fix.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
            return false;
          }

          return failureCount < 1;
        },
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        // A mutation is never retried blindly: it may not be idempotent (§9, 13-ui-ux).
        retry: false,
      },
    },
  });
}
